<template>
    <div>
        <!-- Start Preloader -->
        <div class="spinner-wrapper">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
        <!-- End preloader -->
        <!-- Home Start-->
        <section class="home-section" id="home">
            <!-- Line Animations Effect-->
            <div class="lines">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>
            <!-- Circle Animations Effect-->
            <ul class="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <div class="home-bg">
                <div class="welcome-text-area">
                    <div class="area-bg"></div>
                    <div class="welcome-area">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="welcome-text text-center text-shadow">
                                        <h1 class="wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">¿Sabor único o experiencia agradable?</h1><br>
                                    </div>
                                    <div v-if="screenWidth >= 750" class="welcome-text text-center">
                                        <h2 class="wow fadeInUp text-shadow" data-wow-delay="0.6s" data-wow-duration="1s">¡En Merengón Bávaro disfrutas las dos!</h2><br>
                                    </div>
                                </div>
                            </div>
                            <!-- <vue-carrusel/> -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="welcome-img d-flex justify-content-center align-items-center wow fadeInUp" data-wow-delay="1s" data-wow-duration="1.5s">
                                        <picture>
                                            <source srcset="assets/images/slider-img/casita-banner.webp" type="image/webp">
                                            <img src="assets/images/slider-img/casita-banner.jpg" class="img-fluid casita-banner-img" alt="Vista exterior de Merengón Bávaro en el cañón del Combeima" :width="screenWidth >= 750 ? 1200 : 600" :height="screenWidth >= 750 ? 800 : 400" fetchpriority="high">
                                        </picture>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <a href="#aboutus" class="scroll-next"><img src="assets/images/down-arrow.png" class="img-fluid" alt="" /></a>
        </section>
        <!-- Home End -->
        <!-- Start About-Us -->
        <section class="section" id="aboutus">
            <div class="container">
                <div class="title-block mx-auto">
                    <div class="section_title mb-4 text-center">
                        <h2 v-if="screenWidth < 750"><span>¡En Merengón Bávaro disfrutas las dos!</span></h2>
                        <span class="scroll-title z-index-class" data-enllax-ratio="2.5" data-enllax-type="foreground" data-enllax-direction="horizontal">Merengón Bávaro</span>
                        <p class="section_subtitle mx-auto black-font">Aquí encontrarás una gran variedad de postres, bebidas y el sabor original de nuestro producto estrella: el merengón, junto al paisaje del cañón del Combeima.</p><br>
                        <p class="section_subtitle mx-auto black-font">Te esperamos en nuestro único punto de venta, ubicado en la vereda Berlín, cañón del Combeima, a pocos minutos de Ibagué, Colombia.</p>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-6 col-sm-12">
                        <div class="about-image-block wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="1.5s">
                            <!-- <img src="assets/images/aboutus/about01.jpg" class="img-fluid" alt="" /> -->
                            <img src="assets/images/aboutus/merengon.png" class="img-fluid rounded-img" alt="Merengón artesanal de Merengón Bávaro®" loading="lazy" />
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="about-text-block wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="1.5s">
                            <div class="about-content">
                                <h4>
                                    Nuestros horarios  <br />de atención:
                                </h4>
                                <ul>
                                    <li>Lunes a viernes de 1:00 p.m. a 7:30 p.m </li>
                                    <li>Sábados, domingos y festivos de 10:00 a.m. a 8:00 p.m </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-12 col-sm-12">
                        <div class="about-text-block wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="1.5s">
                            <div class="about-content">
                                <h4 class="text-center">Escoge tu Merengón</h4>
                                <vue-winwheel :segments="wheel_options" />
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="current_product_home && current_product_home.picture_value" class="row align-items-center">
                    <div class="col-md-6 col-sm-12 order-md-2">
                        <div class="about-image-block wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="1.5s">
                            <RouterLink to="/postres">
                                <img :src="'assets/images/aboutus/' + current_product_home.picture_value" class="img-fluid img-margin rounded-img" :alt="current_product_home.text_value + ' - Merengón Bávaro® Ibagué'" width="80%" height="80%" loading="lazy" />
                            </RouterLink>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 order-md-1">
                        <div class="about-text-block wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="1.5s">
                            <div class="about-content">
                                <h4>
                                    {{ current_product_home.text_value }}
                                </h4>
                                <div class="text">{{ current_product_home.aditional_info }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-6 col-sm-12 order-md-1">
                        <div class="about-text-block wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="1.5s">
                            <div class="about-content">
                                <router-link to="/momentos-bavaros">
                                    <h4>
                                        Momentos<br />Bávaros
                                    </h4>
                                    <div class="text">
                                        <b>Comparte tus mejores momentos en Merengón Bávaro</b><br><br>
                                    </div>
                                    <div class="text">Etiquétanos en Instagram @merengonbavaro  o Facebook @merengonbavaro91, con el hashtag  #UnMerengónCon #UnMerengonPara.</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 order-md-2">
                        <div class="about-image-block wow fadeInUp img-margin" data-wow-delay="0.4s" data-wow-duration="1.5s">
                            <vue-instagram v-if="instagram_reel && instagram_reel.text_value" v-bind:reel_id="'https://www.instagram.com/reel/' + instagram_reel.text_value + '/embed/captioned/'"></vue-instagram>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    //WOW JS
    import { WOW } from 'wowjs';
    //ENLLAX JS
    import '../assets/js/jquery.enllax.min.js';
    //TYPED JS
    import '../assets/js/typed.min.js';
    //OWL CAROUSEL JS
    import 'owl.carousel/dist/assets/owl.carousel.css';
    import 'owl.carousel/dist/assets/owl.theme.default.css';
    import 'owl.carousel';

    import VueWinwheel from "../components/adicionales/Ruleta.vue"
    import VueInstagram from "../components/adicionales/Instagram.vue"
    import VueCarrusel from "../components/adicionales/Carrusel.vue"
import { RouterLink } from 'vue-router';


    export default {
        name: 'index',
        metaInfo: {
            title: 'Merengón Bávaro® | Postres y Bebidas en el Cañón del Combeima, Ibagué',
            meta: [
                { name: 'description', content: 'Disfruta el sabor original del merengón y otros postres artesanales en el cañón del Combeima, Ibagué. Abierto lunes a viernes 1pm-7:30pm y fines de semana 10am-8pm.' },
                { property: 'og:title', content: 'Merengón Bávaro® | Postres y Bebidas en el Cañón del Combeima' },
                { property: 'og:description', content: 'Disfruta el sabor original del merengón y otros postres artesanales en el cañón del Combeima, Ibagué.' },
                { property: 'og:url', content: 'https://merengonbavaro.com/' },
                { name: 'twitter:title', content: 'Merengón Bávaro® | Postres en el Cañón del Combeima' },
                { name: 'twitter:description', content: 'Disfruta el sabor original del merengón y otros postres artesanales en el cañón del Combeima, Ibagué.' },
            ],
            link: [
                { rel: 'canonical', href: 'https://merengonbavaro.com/' }
            ],
            script: [
                {
                    type: 'application/ld+json',
                    json: {
                        '@context': 'https://schema.org',
                        '@type': ['FoodEstablishment', 'LocalBusiness'],
                        name: 'Merengón Bávaro®',
                        description: 'Emprendimiento familiar pionero en la preparación de merengón y postres artesanales en el cañón del Combeima desde 1991.',
                        url: 'https://merengonbavaro.com',
                        telephone: '+573185106016',
                        email: 'merengonbavaro@gmail.com',
                        image: 'https://merengonbavaro.com/assets/images/thumbnail_seo.png',
                        logo: 'https://merengonbavaro.com/assets/images/logo.png',
                        priceRange: '$',
                        servesCuisine: 'Postres colombianos',
                        foundingDate: '1991',
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: 'Km 5.5 vereda Berlín, cañón del Combeima',
                            addressLocality: 'Ibagué',
                            addressRegion: 'Tolima',
                            addressCountry: 'CO'
                        },
                        geo: {
                            '@type': 'GeoCoordinates',
                            latitude: 4.4153,
                            longitude: -75.2721
                        },
                        openingHoursSpecification: [
                            {
                                '@type': 'OpeningHoursSpecification',
                                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                                opens: '13:00',
                                closes: '19:30'
                            },
                            {
                                '@type': 'OpeningHoursSpecification',
                                dayOfWeek: ['Saturday', 'Sunday'],
                                opens: '10:00',
                                closes: '20:00'
                            }
                        ],
                        sameAs: [
                            'https://www.facebook.com/merengonbavaro91/',
                            'https://www.instagram.com/merengonbavaro'
                        ]
                    }
                }
            ]
        },
        mounted() {
            this.init();
            window.scrollTo(0, 0);
            window.addEventListener('resize', this.updateScreenSize)
        },
        data () {
                return {
                    wheel_options:[
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Fresa',
                                picture: 'merengón_de_fresa'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Durazno',
                                picture: 'merengón_de_durazno'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Guanábana',
                                picture: 'merengón_de_guanábana'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Tropical',
                                picture: 'merengón_tropical'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Café',
                                picture: 'merengón_de_café'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Limón',
                                picture: 'merengón_de_limón'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Maracuyá',
                                picture: 'merengón_de_maracuyá'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Frutos rojos',
                                picture: 'merengón_de_frutos_rojos'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Nutella',
                                picture: 'merengón_de_nutella'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Coco',
                                picture: 'merengón_de_coco'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#9bb43c',
                                text:'Aguacate',
                                picture: 'merengón_de_aguacate'
                            },
                            {
                                textFillStyle: '#000',
                                fillStyle: '#f26529',
                                text:'Frutos ácidos',
                                picture: 'merengón_de_frutos_ácidos'
                            }
                    ],
                    dynamic_data: [],
                    instagram_reel: '',
                    current_product_home: '',
                    screenWidth: window.innerWidth
                }
            },
        beforeCreate() {
            this.$store.dispatch('retrieveDynamicData')
                .then(data => {
                    this.dynamic_data = data;
                    this.instagram_reel = this.findItemByName('home_instagram_reel',this.dynamic_data);
                    this.current_product_home = this.findItemByName('current_product_home',this.dynamic_data);
                    console.log(this.current_product_home);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        components: {
            VueWinwheel,
            VueInstagram,
            VueCarrusel
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateScreenSize)
        },
        methods: {
            init() {
                this.hidePreloader();
                this.initWowAnimation();
                this.initEnllax();
                // this.initTyping();
                this.initClientSlider();
                this.initAccordian();
                this.windowScroll();
            },
            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            },
            /*----ONSCROLL JS-----*/
            windowScroll() {
                var self = this;
                $(window).on("scroll", function () {
                    self.initCounter();
                });
            },
            /*----WOW ANIMATION-----*/
            initWowAnimation() {
                var length = $('.wow').length;
                if (length >= 1) {
                    const wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: 0,
                    });
                    wow.init();
                }
            },
            /*----ENLLAX SCROLLING-----*/
            initEnllax() {
                $('.scroll-title').enllax();
            },
            /*----ACCORDIAN-----*/
            initAccordian() {
                $(".question-card").on('click', function () {
                    if ($(this).hasClass('active')) {
                        $('.question-card').removeClass('active');
                        $(this).removeClass('active')
                    } else {
                        $('.question-card').removeClass('active');
                        $(this).addClass('active')
                    }
                });
            },
            /*----COUNTER-----*/
            initCounter() {
                var length = $('#counter').length;
                if (length >= 1) {
                    var a = 0;
                    var oTop = $('#counter').offset().top - window.innerHeight;
                    if (a == 0 && $(window).scrollTop() > oTop) {
                        $('.counter-value').each(function () {
                            var $this = $(this),
                                countTo = $this.attr('data-count');
                            $({
                                countNum: $this.text()
                            }).animate({
                                countNum: countTo
                            }, {
                                duration: 2000,
                                easing: 'swing',
                                step: function () {
                                    $this.text(Math.floor(this.countNum));
                                },
                                complete: function () {
                                    $this.text(this.countNum);
                                }
                            });
                        });
                        a = 1;
                    }
                }
            },
            /*----TESTIMONIAL SLIDER-----*/
            initClientSlider() {
                var testimonialCarousel = $('.client-slider');
                if (testimonialCarousel.length > 0) {
                    testimonialCarousel.owlCarousel({
                        margin: 0,
                        loop: false,
                        nav: true,
                        center: false,
                        dots: false,
                        autoplay: true,
                        autoplayTimeout: 5000,
                        items: 3,
                        responsiveClass: true,
                        navText: ['<span class="mdi mdi-arrow-left"></span>', '<span class="mdi mdi-arrow-right"></span>'],
                        responsive: {
                            0: {
                                items: 1,
                            },
                            600: {
                                items: 2,
                            },
                            1000: {
                                items: 2,
                            }
                        }
                    });
                }
            },
            /*----TYPED JS-----*/
            initTyping() {
                $(".typed").typed({
                    strings: ["Improve your Business."],
                    stringsElement: null,
                    typeSpeed: 30,
                    startDelay: 1200,
                    backSpeed: 20,
                    backDelay: 500,
                    loop: true,
                    loopCount: 5,
                    showCursor: false,
                    cursorChar: "|",
                    attr: null,
                    contentType: 'html',
                    callback: function () { },
                    preStringTyped: function () { },
                    onStringTyped: function () { },
                    resetCallback: function () { }
                });
            },
            findItemByName(name,items) {
                const item = items.find(item => item.name === name);
                return item;
            },
            updateScreenSize() {
                this.screenWidth = window.innerWidth
            }
        }
    }
</script>
<style scoped>
    .picture-of-wheel {
        padding-right: 100px;
        padding-left: 100px;
        padding-bottom: 100px;
    }
    .black-font {
        color: #000000 !important;
    }
    .img-margin {
        margin-left: 45px !important
    }
    .text-shadow {
        color: white;
        text-shadow: 2px 2px 4px #000000;
    }
    .z-index-class {
        z-index: -1;
    }
    .casita-banner-img {
        border-top-left-radius: 40px;
        border-top-right-radius: 40px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
    }
    @media (max-width: 750px) {
        .casita-banner-img {
            border-top-left-radius: 24px;
            border-top-right-radius: 24px;
        }
    }
</style>